import axios from 'axios';
import CartAddOn from 'components/cartAddOn/CartAddOn';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {
    setCurrentStep,
    setCartOpenState,
    setHasExtras,
} from 'features/cart/cartSlice';
import { apiConfig } from 'config';
import { SkeletonAddOn } from 'components/cartAddOn';

const CartAddOnWrapper = ({ isMobile = false }) => {
    const dispatch = useDispatch();
    const Lang = useSelector((state) => state.miniBookingWidget?.data?.Lang);
    const items = useSelector((state) => state.cart?.cartItems);
    const firstIncompleteIndex = items.findIndex((item) => !item.isCompleted);
    const selectedItem = useSelector(
        (state) => state.cart?.cartItems[firstIncompleteIndex]
    );
    const selectedItemID = selectedItem?.ID;
    const [extras, setExtras] = useState([]);
    const [isFetching, setIsFetching] = useState(true);
    const changeCartFormState = (state) => {
        dispatch(setCartOpenState(state));
    };
    useEffect(() => {
        if (firstIncompleteIndex === -1) {
            // Use a setTimeout to defer the state update until the next render cycle
            if (items?.length > 0) {
                setTimeout(() => {
                    dispatch(setCurrentStep({ currentStep: 2 }));
                }, 0);
            } else {
                changeCartFormState(false);
            }
        }
    }, [firstIncompleteIndex, setCurrentStep]);

    useEffect(() => {
        if (firstIncompleteIndex !== -1) {
            const fetchAddOns = async () => {
                try {
                    setIsFetching(true);
                    dispatch(setHasExtras(false));
                    const response = await axios.post(apiConfig?.getAddOns, {
                        rateID: selectedItem.rateID,
                        roomTypeID: selectedItem.roomTypeID,
                        cartID: selectedItem.cartID,
                        propCode: selectedItem.hotelCode,
                    });

                    if (response?.data?.length > 0) {
                        // Assuming the extras are available in the response.data
                        const extrasData = response?.data;
                        setExtras(extrasData);
                        dispatch(setHasExtras(true));
                    } else {
                        setExtras([]);
                    }
                } catch (error) {
                    toast.error(Lang?.networkError, {
                        autoClose: true,
                        theme: 'colored',
                    });
                }
                setIsFetching(false);
            };

            fetchAddOns();
        }
    }, [selectedItemID]);
    return (
        <div>
            {!isFetching ? (
                extras.length > 0 ? (
                    extras.map((extra) => (
                        <CartAddOn
                            key={extra.addOnID}
                            title={extra.title}
                            description={extra.description}
                            price={`${extra.price}`}
                            priceText={extra.priceText}
                            priceDescription={extra.priceDescription}
                            addOnText={extra.addOnText}
                            img={extra.img}
                            addOnID={extra.addOnID}
                            minQuantity={extra.minQuantity}
                            maxQuantity={extra.maxQuantity}
                            quantity={extra.quantity}
                            isMobile={isMobile}
                        />
                    ))
                ) : (
                    <p style={{ marginTop: '10px' }}>
                        {Lang?.noAddOnsAvailable}
                    </p>
                )
            ) : (
                <SkeletonAddOn isMobile={isMobile} />
            )}
        </div>
    );
};

CartAddOnWrapper.propTypes = {
    isMobile: PropTypes.bool,
};

export default CartAddOnWrapper;
